<template>
<section class="exhibition-movie-section _edit-section">
    <div class="section-inner">

        <!-- 展示会情報 (ショップの場合は非表示にする) -->
        <div class="block" v-if="!this.isShop">
            <div class="md_hidden-content-wrap">
                <button type="button" class="trigger js-toggle-on _on"><span>展示会・ポップアップ情報</span></button>
                <div class="content"><div class="content-inner">
                    
                    <div class="exhibition-item" v-for="(exhibition_title, i) in exhibition_titlesList" v-bind:key="i" >
                        <!-- Radio -->
                        <div style="display: flex; margin-bottom: 2rem; justify-content: center; gap: 1rem;">
                            <div class="item form_radio">
                                <input :id="`select-exhibit-true${i}`" type="radio" class="" :value="0" v-model="exhibition_title.type">
                                <label :for="`select-exhibit-true${i}`">
                                    <span>展示会</span>
                                </label>
                            </div>
                            <div class="item form_radio">
                                <input :id="`select-popup-true${i}`" type="radio" class="" :value="1" v-model="exhibition_title.type">
                                <label :for="`select-popup-true${i}`">
                                    <span>ポップアップ</span>
                                </label>
                            </div>
                        </div>

                        <div class="item form_text" style="margin-bottom: 2rem;">
                            <input type="text" maxlength="250" id="exhibition_title-date1" class="date" placeholder="" v-model="exhibition_title.name">
                            <label for="exhibition_title-date1" class="m-label"><span>コレクションタイトル</span></label>
                        </div>

                        <!--Group-->
                        <div class="input-group" v-for="(exhibition, index) in exhibition_title.exhibitions" v-bind:key="index">
                            <!--地域-->
                            <div class="item form_select">
                                <select name="exhibition-city" id="exhibition-city1" v-model="exhibition.area">
                                    <option value="" hidden>開催地を選択してください</option>
                                    <option
                                    v-for="area_prefecture in this.$store.state.register.set.area_prefectures"
                                    v-bind:key="area_prefecture.id"
                                    v-bind:value="area_prefecture.name"
                                    >{{ area_prefecture.name }}</option>
                                </select>
                            </div>
                            <!--日時-->
                            <div class="item form_text">
                                <input type="text" maxlength="250" id="exhibition-date1" class="date" placeholder="" v-model="exhibition.date_time">
                                <label for="exhibition-date1" class="m-label"><span>日時</span></label>
                            </div>
                            <!--会場住所-->
                            <div class="item form_text">
                                <input type="text" maxlength="250" id="exhibition-address1" placeholder=" " v-model="exhibition.address">
                                <label for="exhibition-address1" class="m-label"><span>会場住所</span></label>
                            </div>
                            <!--会場住所-->
                            <div class="item form_text">
                                <input type="text" maxlength="250" id="exhibition-map-url1" placeholder=" " v-model="exhibition.google_map_url">
                                <label for="exhibition-map-url1" class="m-label"><span>Google Map Url</span></label>
                            </div>
                            <!--詳細-->
                            <div class="item form_text">
                                <textarea name="exhibition-detail1" id="exhibition-detail" maxlength="250" placeholder=" " data-dl-input-translation="true" v-model="exhibition.text"></textarea>
                                <label for="exhibition-detail1" class="m-label"><span>詳細</span></label>
                            </div>
                            <!--追加削除-->
                            <div class="md_add-del-wrap">
                                <button type="button" class="dele" v-on:click="deleteExhibition(i, index)">
                                    <div class="md_icon-btn">
                                        <div class="inner"><SvgIconDelete /></div>
                                    </div>
                                </button>
                                <button type="button" class="add" v-on:click="addExhibition(i, index)"><span></span><span></span></button>
                            </div>
                        </div><!--/.Group-->

                        <!--追加削除-->
                        <div class="md_add-del-wrap">
                            <button type="button" class="dele" v-on:click="deleteExhibitionTitles(i)">
                                <div class="md_icon-btn">
                                    <div class="inner"><SvgIconDelete /></div>
                                </div>
                            </button>
                            <button type="button" class="add" v-on:click="addExhibitionTitles(i)"><span></span><span></span></button>
                        </div>
                    </div>
                    <!--追加削除-->
                    <div class="md_add-del-wrap" v-if="exhibition_titles.length == 0">
                        <button type="button" class="dele" v-on:click="deleteExhibitionTitles(i)">
                            <div class="md_icon-btn">
                                <div class="inner"><SvgIconDelete /></div>
                            </div>
                        </button>
                        <button type="button" class="add" v-on:click="addExhibitionTitles(i)"><span></span><span></span></button>
                    </div>

                </div></div><!--/.Inner-->
            </div><!--/.md_hidden-content-wrap-->
        </div>

        <!-- 動画を見る -->
        <div class="block" v-if="showMovie">
            <div class="md_hidden-content-wrap">
                <button type="button" class="trigger js-toggle-on _on"><span>MOVIE</span></button>
                <div class="content"><div class="content-inner">

                    <!--Movie-->
                    <div class="movie-card" v-for="(youtube, index) in youtubeList" v-bind:key="index">
                        <iframe v-if="youtube.url" width="560" height="315" :src="youtube.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <div class="item form_text">
                            <input type="text" maxlength="250" id="movie-url1" placeholder=" " :value="youtube.url" v-on:change="changeYoutube($event, index)">
                            <label for="movie-url1" class="m-label"><span>Youtube Url</span></label>
                        </div>
                        <!--追加削除-->
                        <div class="md_add-del-wrap" v-bind:class="{ '_center': 1 < youtubes.length }">
                            <button type="button" class="dele" v-on:click="deleteYoutube(index)">
                                <div class="md_icon-btn">
                                    <div class="inner"><SvgIconDelete /></div>
                                </div>
                            </button>
                            <button type="button" class="add" v-if="youtubes.length < 2" v-on:click="addYoutube(index)"><span></span><span></span></button>
                        </div>
                    </div>

                    <!--追加削除-->
                    <div class="md_add-del-wrap" v-if="youtubes.length == 0">
                        <button type="button" class="dele" v-on:click="deleteYoutube(index)">
                            <div class="md_icon-btn">
                                <div class="inner"><SvgIconDelete /></div>
                            </div>
                        </button>
                        <button type="button" class="add" v-on:click="addYoutube(index)"><span></span><span></span></button>
                    </div>

                </div></div><!--/.Inner-->
            </div><!--/.md_hidden-content-wrap-->
        </div>
        <AlertModal 
        v-if="showAlertModal" 
        @close="closeAlertModal" 
        :title="alert_modal_title" 
        :message="alert_modal_message"
        :mode="alert_modal_mode" 
        />
    </div>
</section>
</template>

<style>
._center {
    text-align: center;
    display:block;
}
</style>

<script>
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'
    //Svg
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        components: {
            "AlertModal": AlertModal,
            SvgIconDelete,
        },
        props: {
            showMovie: Boolean,
        },
        data() {
            return {
                isShop: false,
                exhibition_titles: [{
                    name: '',
                    type: '',
                    exhibitions: [{
                        area: '',
                        date_time: '',
                        address: '',
                        google_map_url: '',
                        text: '',
                    }],
                }],
                youtubes: [{
                    url: '',
                }],
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            };
        },
        watch: {
            exhibition_titles: {
                handler: function () {
                    this.$store.state.register.form.editExhibitionTitles = this.exhibition_titles;
                },
                deep: true
            },
            youtubes: {
                handler: function (value) {
                    this.$store.state.register.form.editYoutube = this.youtubes;
                },
                deep: true
            }
        },
        mounted: function() {

            let currentUrlPath = window.location.pathname;
            if (currentUrlPath.includes('shop')) {
                this.isShop = true;
            } else {
                this.isShop = false;
            }

            if (this.$store.state.detail.set.brand.exhibition_titles && this.$store.state.detail.set.brand.exhibition_titles.length != 0) {
                this.exhibition_titles = this.$store.state.detail.set.brand.exhibition_titles;
                this.$store.state.register.form.editExhibitions = this.$store.state.detail.set.brand.exhibition_titles;
            }
            if (this.$store.state.detail.set.brand.youtubes && this.$store.state.detail.set.brand.youtubes.length != 0) {
                this.youtubes = this.$store.state.detail.set.brand.youtubes;
                this.$store.state.register.form.youtubes = this.$store.state.detail.set.brand.youtubes;
            }
        },
        computed: {
            exhibition_titlesList() {
                return this.exhibition_titles;
            },
            youtubeList() {
                return this.youtubes;
            },
        },
        methods: {
            addExhibitionTitles: function(i) {
                this.exhibition_titles.splice(i + 1, 0, 
                    {
                        name: '',
                        type: '',
                        exhibitions: [{
                            area: '',
                            date_time: '',
                            address: '',
                            google_map_url: '',
                            text: '',
                        }],
                    }
                );
            },
            deleteExhibitionTitles: function(i) {
                this.exhibition_titles.splice(i, 1);
            },
            addExhibition: function(i, index) {
                this.exhibition_titles[i].exhibitions.splice(index + 1, 0, 
                    {
                        area: '',
                        date_time: '',
                        address: '',
                        google_map_url: '',
                        text: '',
                    }
                );
            },
            deleteExhibition: function(i, index) {
                if (this.exhibition_titles[i].exhibitions.length == 1) {
                    this.exhibition_titles.splice(i, 1);
                } else {
                    this.exhibition_titles[i].exhibitions.splice(index, 1);
                }
            },
            addYoutube: function(index) {
                console.log(this.youtubes);
                if (this.youtubes.length < 2) {
                    this.youtubes.splice(index + 1, 0, 
                        {
                            url: '',
                        }
                    );
                }
            },
            deleteYoutube: function(index) {
                this.youtubes.splice(index, 1);
            },
            changeYoutube: function(e, index) {
                var url = e.target.value;

                var result = url.indexOf( 'embed' );

                if (result !== -1) {
                    //https://www.youtube.com/embed/hogehogeの場合
                    var result = url.substr( 30 );
                    this.youtubes[index].url = 'https://www.youtube.com/embed/' + result;
                } else {
                    var result = url.indexOf( 'watch?' );
                    
                    if(result !== -1) {
                        //https://www.youtube.com/watch?v=mTgpVsa61Kgの場合
                        var result = url.substr( 32 );
                        this.youtubes[index].url = 'https://www.youtube.com/embed/' + result;
                    } else {
                        //https://youtu.be/mTgpVsa61Kgの場合
                        var result = url.indexOf( 'youtu' );
                        if(result !== -1) {
                            var result = url.substr( 17 );
                            this.youtubes[index].url = 'https://www.youtube.com/embed/' + result;
                        }
                        else {
                            this.openAlertModal('error', 'エラー', 'YoutubeのURlを入力してください。'); //確認済み
                            this.youtubes[index].url = '';
                        }
                    }
                }

            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            }
        }
    }
</script>

